import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import Button from 'src/shared-components/Button';
import { Select, Toggle } from 'src/shared-components/Form';
import * as Yup from 'yup';
interface SetRateFormProps {
  timeAvailable?: string;
  equityAccepted?: boolean;
  submitForm: (values: any) => void;
  buttonText?: string;
}
const SetRateForm = ({ timeAvailable, equityAccepted, submitForm, buttonText = 'Submit' }: SetRateFormProps) => {
  const form = useFormik({
    initialValues: {
      timeAvailable: '',
      equityAccepted: false,
    },
    onSubmit: values => {
      submitForm(values);
    },
    validationSchema: Yup.object({
      timeAvailable: Yup.string().required('Please enter your timeAvailable'),
      equityAccepted: Yup.boolean().required(),
    }),
  });

  const { isValid, handleSubmit, setFieldValue, values, errors, handleBlur, setValues } = form;

  timeAvailable = timeAvailable ?? '';
  equityAccepted = equityAccepted ?? false;

  useEffect(() => {
    form.setValues({ timeAvailable, equityAccepted });
  }, [timeAvailable, equityAccepted]);

  const changeEquityAccepted = (value: boolean) => {
    setFieldValue('equityAccepted', !values.equityAccepted);
  };

  const options = [
    { value: 'FEW_HOURS_PER_WEEK', label: 'A few hours per week' },
    { value: 'ONE_DAY_PER_WEEK', label: '1 day/week' },
    { value: 'TWO_DAYS_PER_WEEK', label: '2 days/week' },
    { value: 'THREE_DAYS_PER_WEEK', label: '3 days/week' },
    { value: 'FOUR_DAYS_PER_WEEK', label: '4 days/week' },
    { value: 'FIVE_DAYS_PER_WEEK', label: '5 days/week' },
    { value: 'NOT_AVAILABLE_NOW', label: 'Not available now' },
  ];

  return (
    <FormikProvider value={form}>
      <div className="flex flex-col gap-y-5">
        <Select options={options} required name="timeAvailable" label="CURRENT timeAvailable" placeholder="3 days/wk" />
        <Toggle
          checked={equityAccepted}
          label="Looking for projects that pay partly in equity"
          onChange={changeEquityAccepted}
        />
        <Button
          onClick={() => handleSubmit()}
          size="lg"
          className="mt-4"
          roundness="md"
          color="black"
          fullWidth
          disabled={!isValid}
        >
          {buttonText}
        </Button>
      </div>
    </FormikProvider>
  );
};
export default SetRateForm;
